document.addEventListener("DOMContentLoaded", function () {
  var script = document.createElement('script');
  script.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
  script.defer = true;
  script.onload = function () {
    merchantwidget.start({
      position: 'RIGHT_BOTTOM',
      region: 'CA'
    });
  };
  document.head.appendChild(script);
});